'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userPaymentDetails = require('./user-payment-details.html');

var _userPaymentDetails2 = _interopRequireDefault(_userPaymentDetails);

var _userPaymentDetails3 = require('./user-payment-details.controller');

var _userPaymentDetails4 = _interopRequireDefault(_userPaymentDetails3);

require('./user-payment-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPaymentDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template: _userPaymentDetails2.default,
  controller: _userPaymentDetails4.default,
  controllerAs: 'vm'
};

exports.default = userPaymentDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-payment-details/user-payment-details.component.js
 **/